var map = {
	"./yx1-en.jpg": "d44f",
	"./yx1-zh.jpg": "6069",
	"./yx2-en.jpg": "d9bb",
	"./yx2-zh.jpg": "fd1e",
	"./yx3-en.jpg": "0785",
	"./yx3-zh.jpg": "1481",
	"./yx4-en.jpg": "91a7",
	"./yx4-zh.jpg": "5bce",
	"./yx5-en.jpg": "064e",
	"./yx5-zh.jpg": "e1dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79ef";